import React, { useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Container,
  Box,
  Grid,
  Card,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import Footer from "../../components/Footer";
import AdminDrawer from "../../components/AdminDrawer";

import { getAllApprovalList, adminApproveSignup } from "../../apis";
import _ from "lodash";
import Navbar from "../../components/Navbar";
import AdminModulesCard from "../../components/AdminModulesCard";
import LogoImage from "../../assets/Images/Vector.png";
import "../../App.css";

const AdminDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user-info"));
  const userID = user?.googleId ? user.googleId : user._id;

  const [request, setRequest] = useState([]);
  const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const result = await getAllApprovalList();
  //     setRequest(result.data.userInfo);
  //   };

  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   if (request.length) {
  //     setLoading(false);
  //     console.log(request);
  //   }
  // }, [request]);

  // const ApproveButtonHandler = async (id) => {
  //   let data = await adminApproveSignup({ serviceProviderId: id });
  //   if (data) {
  //     getAllApprovalList().then((data) => {
  //       setRequest(data.data.userInfo);
  //     });
  //   }
  // };

  return (
    <>
      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="Home" />
          </Grid>
          <Grid item xs={10}>
            <Box
              sx={{ display: "flex" }}
              justifyContent="center"
              alignItems="center"
              style={{ height: "70vh" }}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
                style={{ width: "100%" }}
              >
                <img
                  src={LogoImage}
                  alt="logo"
                  style={{ height: "75px", width: "100px" }}
                />
                <span
                  className="default-color"
                  style={{
                    fontWeight: "bold",
                    fontSize: "50px",
                  }}
                >
                  Amannat
                </span>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </div>
      {/* <Typography className="mb-10 mt-16" style={{ fontWeight: "bold" }}>
          Admin Dashboard
        </Typography>
        <Grid container className="mt-4" rowSpacing={5}>
          <Grid xs={12} sm={6} md={4} lg={4} item className="categories-card">
            <Link to="/admin/registration-manager">
              <AdminModulesCard cardTitle="Registration Manager" />
            </Link>
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={4} item className="categories-card">
            <AdminModulesCard cardTitle="Disputes Manager" />
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={4} item className="categories-card">
            <AdminModulesCard cardTitle="Security Manager" />
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={4} item className="categories-card">
            <Link to="/admin/HR-manager">
              <AdminModulesCard cardTitle="HR Manager" />
            </Link>
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={4} item className="categories-card">
            <AdminModulesCard cardTitle="Personal Info" />
          </Grid>
        </Grid> */}

      {/* <Container>
          {request.map((item, index) => (
            <div className="user-card mb-12">
              <Card sx={{ display: "flex" }}>
                <Grid container>
                  <Grid item md={2}>
                    <div className="m-5">
                      <img
                        src={item.serviceProviderInfo.personalInfo.image[0]}
                        alt="Banner Person"
                        style={{ width: "120px" }}
                      />
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <Stack spacing={1}>
                      <Stack className="mt-2">
                        <Typography variant="h6" gutterBottom component="div">
                          {item.serviceProvider.fullName}
                        </Typography>
                      </Stack>
                      <Stack className="mt-2">
                        <Typography
                          variant="button"
                          display="block"
                          gutterBottom
                        >
                          {item.serviceProviderInfo.expertise.category} |{" "}
                          {item.serviceProviderInfo.expertise.subCategory}
                        </Typography>
                      </Stack>

                      <Stack>
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="truncate"
                        >
                          {item.serviceProviderInfo.personalInfo.description}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item md={4}>
                    <div
                      className="mt-5"
                      style={{ display: "flex", justifyContent: "end" }}
                    >
                      <Button variant="outlined" color="error" size="small">
                        Reject
                      </Button>

                      <Button
                        variant="contained"
                        className="ml-7 mr-7"
                        size="small"
                        color="success"
                        onClick={() =>
                          ApproveButtonHandler(
                            item.serviceProviderInfo.serviceProviderId
                          )
                        }
                      >
                        Approve
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Card>
            </div>
          ))}
        </Container>
        <Footer /> */}
    </>
  );
};

export default AdminDashboard;
